import { render } from "./Confirm.vue?vue&type=template&id=b6324c5a"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/auth/Confirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6324c5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6324c5a', __exports__)) {
    api.reload('b6324c5a', __exports__)
  }
  
  module.hot.accept("./Confirm.vue?vue&type=template&id=b6324c5a", () => {
    api.rerender('b6324c5a', render)
  })

}


export default __exports__